import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import MCPClasses from '@/pages/mcp/MCPClasses';
import MCPInstances from '@/pages/mcp/MCPInstances';
import { McpIcon, McpInstanceIcon } from '@/pages/mcp/shared';

export default function MCPsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<'class' | 'instance'>(() => {
    const tab = searchParams.get('tab');
    return tab === 'instance' ? 'instance' : 'class';
  });

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'instance' || tab === 'class') {
      setActiveTab(tab);
    }
  }, [searchParams]);

  const handleTabChange = (id: string) => {
    setActiveTab(id as 'class' | 'instance');
    setSearchParams({ tab: id });
  };

  const tabMeta = {
    class: { label: 'MCP 模版', icon: <McpIcon /> },
    instance: { label: '实例', icon: <McpInstanceIcon /> },
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground tracking-tight">MCP 管理</h1>
        <p className="text-sm text-muted-foreground mt-1">
          管理 MCP 服务模版与实例，挂载到 Agent 上为模型提供工具
        </p>
      </div>

      <div className="flex items-center gap-1 p-1 bg-muted rounded-lg w-fit">
        {(['class', 'instance'] as const).map((tab) => {
          const meta = tabMeta[tab];
          return (
            <button
              key={tab}
              onClick={() => handleTabChange(tab)}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
                activeTab === tab
                  ? 'bg-background shadow-sm text-foreground'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <span className={activeTab === tab ? 'text-primary' : ''}>{meta.icon}</span>
              {meta.label}
            </button>
          );
        })}
      </div>

      {activeTab === 'class' && <MCPClasses />}
      {activeTab === 'instance' && <MCPInstances />}
    </div>
  );
}
